import { companyConstants } from "../../actions/company/index.js";

import { connectionsConstants } from "../../actions/connections/index";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  },
  preSearchedCompany: null
};

export default function company(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case companyConstants.CLEAR_SEARCHED_COMPANY:
    return {
      ...defaultS,
      preSearchedCompany: null,
      companies: defaultS.preSearchedCompany ? defaultS.preSearchedCompany : defaultS.companies
    };
  case companyConstants.LOAD_SEARCHED_COMPANY_SUCCESS:
    return {
      ...defaultS,
      status: {
        started: false,
        error: false,
        ended: true
      },
      preSearchedCompany: payload.companiesList,
      searchedCompany: payload.data.items
    };
  case companyConstants.LOAD_COMPANY_START:
  case companyConstants.LOAD_STUDIO_COMPANIES_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case companyConstants.LOAD_COMPANY_SUCCESS:
  case companyConstants.LOAD_STUDIO_COMPANIES_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      companies: payload.isAppend ? defaultS.companies.concat(payload.result) : payload.result,
      hasMoreItems: payload.hasMoreItems
    };
  case companyConstants.LOAD_COMPANY_ERROR:
  case companyConstants.LOAD_STUDIO_COMPANIES_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: {
          code: payload && payload.code ? payload.code : 500,
          message: payload && payload.message ? payload.message : "Errore"
        }
      }
    };
  case connectionsConstants.FETCH_BUSINESS_CONSULTANTS_SUCCESS:
    let addedCommercialistiList = defaultS.companies ? defaultS.companies : [];
    for (let i = 0; i < addedCommercialistiList.length; i++) {
      if (addedCommercialistiList[i].codiceFiscale === payload.idAzienda || addedCommercialistiList[i].id === payload.idAzienda) {
        addedCommercialistiList[i].commercialistiList = payload.list;
      }
    }
    return {
      ...defaultS,
      companies: addedCommercialistiList
    };
  case "appendCompany": 
    return {
      ...defaultS,
      companies: [...defaultS.companies, payload]
    };
  default:
    return defaultS;
  }
}
